<template>
  <!--  创建企业弹窗  -->
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="false"
    :close-on-click-modal="false"
    top="30vh"
    width="680px"
    custom-class="create-company-dialog"
  >
    <div class="dialog-title" slot="title">创建企业</div>
    <el-form
      style="width: 459px; margin: 0 auto"
      ref="createCompanyForm"
      :model="formInfo"
      label-width="125px"
      label-position="right"
    >
      <el-form-item label="主体类型">
        <el-radio-group
          v-model="formInfo.companyType"
          @change="handleChangeCompanyType"
        >
          <el-radio label="1">个人（散户）</el-radio>
          <el-radio label="2">企业/合作社/家庭农场等</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="formInfo.companyType == '1' ? '姓名' : '企业名称'">
        <el-input
          style="width: 334px"
          v-model="formInfo.companyName"
          @input="inputCompanyName"
          :placeholder="
            formInfo.companyType == '1'
              ? '例如：张三'
              : '例如：江西江天农业科技有限公司'
          "
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="formInfo.companyType == '1' ? '地块位置' : '基地所在地'"
      >
        <!--   选择省份    -->
        <el-select
          v-model="formInfo.provinceId"
          @change="changeProvince"
          placeholder="省份"
          style="width: 104px"
        >
          <el-option
            v-for="province in provinceList"
            :key="province.id"
            :value="province.id"
            :label="province.areaName"
          ></el-option>
        </el-select>
        <!--   选择城市    -->
        <el-select
          v-model="formInfo.cityId"
          @change="changeCity"
          placeholder="城市"
          style="width: 104px; margin: 0 11px"
        >
          <el-option
            v-for="city in cityList"
            :key="city.id"
            :value="city.id"
            :label="city.areaName"
          ></el-option>
        </el-select>
        <!--   选择区/县   -->
        <el-select
          v-show="areaList.length"
          v-model="formInfo.areaId"
          placeholder="区/县"
          style="width: 104px"
        >
          <el-option
            v-for="area in areaList"
            :key="area.id"
            :value="area.id"
            :label="area.areaName"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="createCompany">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getProvinceCityArea } from "@/api/request/snkd.foundation";
import { getStorage } from "@/utils/storage";
import { getStrCharLen, cutStrByCharLen, windowHref } from "@/utils";
import { addCompany } from "@/api/request/snkd.user";
export default {
  name: "createCompanyForm",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loaction: null,
      formInfo: {
        companyType: "2",
        companyName: "",
        provinceId: null,
        cityId: null,
        areaId: null,
      },
      provinceList: [],
      cityList: [],
      areaList: [],
    };
  },
  async mounted() {
    // 获取本地的地址信息
    this.location = getStorage("LOCATION") ? getStorage("LOCATION") : null;
    // 获取省份信息
    this.provinceList = await this.getProvinceCityArea(0);
    // 如果缓存中有位置，以缓存中位置为主
    if (this.location) {
      this.formInfo.provinceId = this.location.provinceId;
      // 获取城市列表
      this.cityList = await this.getProvinceCityArea(this.formInfo.provinceId);
      this.formInfo.cityId = this.location.cityId;
      // 获取区列表
      this.areaList = await this.getProvinceCityArea(this.formInfo.cityId);
      this.formInfo.areaId = this.location.areaId;
    }
  },
  methods: {
    inputCompanyName() {
      if (getStrCharLen(this.formInfo.companyName) > 60) {
        this.$message({
          message: "企业名称最多30字",
          type: "warning",
        });
        this.formInfo.companyName = cutStrByCharLen(
          this.formInfo.companyName,
          30
        );
      }
    },
    // 选择省份
    async changeProvince(val) {
      console.log(val);
      this.cityList = await this.getProvinceCityArea(val);
      this.formInfo.cityId = null;
      this.formInfo.areaId = null;
      this.areaList = [];
    },
    // 选择城市
    async changeCity(val) {
      this.areaList = await this.getProvinceCityArea(val);
      this.formInfo.areaId = null;
    },
    // 获取省市区
    getProvinceCityArea(parentId) {
      return getProvinceCityArea({ parentId }).then((res) => {
        // console.log("省市区列表===", res);
        if (res.respCode == 0) {
          return res.obj.list;
        } else {
          return [];
        }
      });
    },
    // 创建企业
    createCompany() {
      if (this.verifyFormInfo()) {
        const { companyType, companyName, provinceId, cityId, areaId } =
          this.formInfo;
        var ajaxJson = {
          authType: companyType,
          companyName,
          farmName: companyName,
          provinceId,
          cityId,
        };
        if (areaId) {
          ajaxJson["countyId"] = areaId;
        }
        addCompany(ajaxJson).then((res) => {
          console.log("添加企业：", res);
          if (res.respCode == 0) {
            windowHref("/home/home", {
              companyId: res.obj.userCompany.companyId,
              farmId: res.obj.farm.farmId,
            });
          }
        });
      }
    },
    // 校验数据
    verifyFormInfo() {
      if (!this.formInfo.companyName) {
        this.$message({
          message:
            this.formInfo.companyType == "1" ? "请输入姓名" : "请输入企业名称",
          type: "warning",
        });
        return false;
      }
      if (!this.formInfo.provinceId) {
        this.$message({
          message: "请选择省份",
          type: "warning",
        });
        return false;
      }
      if (!this.formInfo.cityId) {
        this.$message({
          message: "请选择城市",
          type: "warning",
        });
        return false;
      }
      if (!this.formInfo.areaId && this.areaList.length) {
        this.$message({
          message: "请选择区/县",
          type: "warning",
        });
        return false;
      }
      if (getStrCharLen(this.formInfo.companyName) > 60) {
        this.$message({
          message:
            this.formInfo.companyType == "1"
              ? "姓名最多30字"
              : "企业名称最多30字",
          type: "warning",
        });
        return false;
      }
      return true;
    },
    // 切换主体类型
    handleChangeCompanyType() {
      this.formInfo.companyName = "";
      this.formInfo.provinceId = null;
      this.formInfo.cityId = null;
      this.formInfo.areaId = null;
      this.cityList = [];
      this.areaList = [];
    },
    // 关闭
    handleClose() {
      this.$emit("update:visible", false);
    },
  },
};
</script>

<style scoped></style>
